<template>
  <v-dialog :value="value" @input="e => $emit('input', e)" :max-width="maxWidth" :persistent="persistent">
    <v-card class="rounded-xl pa-8">
      <v-card-text class="pa-0 ma-0">
        <app-modal-container>
          <app-confirm-modal-title :title-icon="titleIcon" :show-title="showTitle" :text-title="textTitle"/>
          <app-modal-row 
            v-if="isHtml"
            :class="{ 'text-center': textCenterMsg,  'mb-2': showTextQuestion}"
          >
            <p class="ma-0 justify-center black--text app-confirm-modal__body" :class="{ 'text-center': textCenterMsg,  'mb-2': showTextQuestion}" v-html="textMsg" />
          </app-modal-row>
          <app-modal-row 
            v-else
            class="justify-center black--text app-confirm-modal__body" 
            :class="{ 'text-center': textCenterMsg,  'mb-2': showTextQuestion}"
          >
              {{textMsg}}
          </app-modal-row>
          <app-modal-row v-if="showTextQuestion" class="justify-center black--text app-confirm-modal__question">
              <span>{{textQuestion}}</span>
          </app-modal-row>
        </app-modal-container>
      </v-card-text>
      <v-card-actions class="mt-8 mb-0 mx-0 pa-0">
        <app-modal-container>
          <app-modal-row 
            class="ma-0 pa-0" 
            :class="showCancelButton && showConfirmButton ? 'justify-space-between' : 'justify-center'"
          >
            <slot name="modal_buttons">
              <app-modal-col 
                cols="12" sm="6" 
                class="ma-0 pa-0 d-flex"
                :class="showCancelButton && showConfirmButton ? 'justify-start' : 'justify-center'"
                v-if="showCancelButton"
              >
                <app-btn 
                  large
                  :block="$vuetify.breakpoint.xs"
                  outlined
                  @click="$emit('cancel')"
                >
                  {{ textCancelButton }}
                </app-btn>
              </app-modal-col>
              <app-modal-col 
                cols="12" sm="6" 
                class="ma-0 pa-0 d-flex"
                :class="showCancelButton && showConfirmButton ? 'justify-end' : 'justify-center'"
                v-if="showConfirmButton"
              >
                <app-btn 
                  large
                  :block="$vuetify.breakpoint.xs"
                  :loading="loading"
                  @click="$emit('confirm')"
                >
                  {{ textConfirmButton }}
                </app-btn>
              </app-modal-col>
            </slot>
          </app-modal-row>
        </app-modal-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AppBtn from '@/components/layout/AppBtn.vue'
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import AppConfirmModalTitle from '@/components/layout/AppConfirmModalTitle.vue';

export default {
 name: 'AppConfirmModal',

 components: { 
  AppBtn,
  AppModalCol,
  AppModalContainer,
  AppModalRow,
  AppConfirmModalTitle,
},

 props: {
  value: {
    type: Boolean,
    required: true,
    },
  loading: {
    type: Boolean,
    default: false,
  },
  width: {
    type: [String, Number],
    required: false,
    default: ''
  },
  textMsg: {
    type: String,
    default: ''
  },
  textCenterMsg: {
    type: Boolean,
    default: true
  },
  showTextQuestion: {
    type: Boolean,
    default: true  
  },
  textQuestion: {
    type: String,
    default: '¿Estás seguro que quieres continuar?'
  },
  titleIcon: {
    type: String,
    default: 'mdi-alert-outline'
  },
  showConfirmButton: {
    type: Boolean,
    default: true,  
  },
  textConfirmButton: {
    type: String,
    default: 'Confirmar'
  },
  showCancelButton: {
    type: Boolean,
    default: true  
  },
  textCancelButton: {
    type: String,
    default: 'Cancelar' 
  },
  showTitle: {
    type: Boolean,
    default: false
  },
  textTitle: {
    type: String,
    default: ''  
  },
  persistent: {
    type: Boolean,
    default: false
  },
  isHtml: {
    type: Boolean,
    default: false
  },
 },

 data() {
  return {}
 },

 computed: {
  maxWidth() {
    if (this.width) {
      return this.width
    }
    if (this.$vuetify.breakpoint.smAndDown) {
      return '100%'
    }
    return '500px'
  }
 },

 methods: {

 }
}
</script>

<style scoped>
.app-confirm-modal__body,
.app-confirm-modal__question {
  font-family: 'Roboto';
  font-style: normal;
  font-size: 20px;
  line-height: 23px;
}

.app-confirm-modal__question {
  font-weight: 700;
  text-align: center;
}

.app-confirm-modal__body {
  font-weight: 400;
}
</style>